import {
    useState, MouseEvent, KeyboardEvent,
} from 'react'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Divider from '@mui/material/Divider'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import {
    MultiActionButtonConfig,
} from 'app/shared-components/MultiActionButton/MultiActionButton.types'

export default function MultiActionButton({
    mainElement, itemsConfig,
}: Readonly<{
    mainElement: JSX.Element,
    itemsConfig: MultiActionButtonConfig[]
}>) {
    const [
        anchorEl,
        setAnchorEl,
    ] = useState<null | HTMLElement>(null)
    const open = Boolean(anchorEl)
    const handleClick = (event: MouseEvent<HTMLDivElement> | KeyboardEvent<HTMLDivElement>) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }

    return (
        <div>
            <div
                role="button"
                onClick={handleClick}
                onKeyDown={handleClick}
                tabIndex={0}
            >
                {mainElement}
            </div>
            {itemsConfig.length === 0 ? null : (
                <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    slotProps={{
                        list: {
                            'aria-labelledby': 'basic-button',
                        },
                    }}
                >
                    {itemsConfig.map((item, index) => {
                        const onClick = () => {
                            handleClose()
                            item.handler()
                        }

                        return (
                            <div key={`multi-action-button-${item.label}`}>
                                {item.addDividerBefore && index !== 0 && <Divider />}
                                <MenuItem
                                    onClick={onClick}
                                >
                                    {
                                        item.icon ? (
                                            <ListItemIcon>
                                                {item.icon}
                                            </ListItemIcon>
                                        ) : null
                                    }
                                    <ListItemText>{item.label}</ListItemText>
                                    {item.element}
                                </MenuItem>
                            </div>
                        )
                    })}
                    <Divider />
                </Menu>
            )}
        </div>
    )
}
